import { render, staticRenderFns } from "./Sliderstars.vue?vue&type=template&id=59a24880&"
import script from "./Sliderstars.vue?vue&type=script&lang=js&"
export * from "./Sliderstars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports